const modalCls = "c2lm1pk5alp";
const iframeCls = "c2li17rt11f";
const throbberTransitionDurationMs = 100;
const throbberCls = "c2ltx5ul3e";

export { iframeCls, modalCls, throbberCls, throbberTransitionDurationMs };
import "./preview-lightbox.style.linaria.module.css";
//# sourceMappingURL=preview-lightbox.style.js.map
